import { useEffect, useState } from "react";

/** Returns true while the user is scrolling down past a small threshold. */
export const useScrollingDown = (threshold = 8) => {
  const [down, setDown] = useState(false);
  useEffect(() => {
    let last = window.scrollY;
    let ticking = false;
    let idle: ReturnType<typeof setTimeout> | undefined;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y < 40) setDown(false);
        else if (y - last > threshold) setDown(true);
        else if (last - y > threshold) setDown(false);
        if (Math.abs(y - last) > threshold) last = y;
        ticking = false;
      });
      if (idle) clearTimeout(idle);
      idle = setTimeout(() => setDown(false), 1200);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (idle) clearTimeout(idle);
    };
  }, [threshold]);
  return down;
};
